export const state = {
  beforePwaInstallPrompt: null,
}

export const getters = {
  beforePwaInstallPrompt(state) {
    return state.beforePwaInstallPrompt
  },
}

export const mutations = {
  SET_BEFORE_PWA_INSTALL_PROMPT(state, event) {
    state.beforePwaInstallPrompt = event
  },
}
